import React, { useMemo, useState } from "react";
import TreeList, { RemoteOperations, Column, SearchPanel, HeaderFilter, Editing, RequiredRule, Lookup, Popup, } from 'devextreme-react/tree-list';
import { useAuth } from "../../../contexts/auth";
import { useDataSource } from "../../../contexts/dataSource"
import { getPropsDataGridPopup, getPropsDataGridEditing, getPropsTreelist } from "../../../utils/default-props";
import { getDataGridCustomToolbar } from "../../../components/default-components/data-grid-custom-toolbar";


function Menus({ setMenuId }) {

    const [focusedRowKey, setFocusedRowKey] = React.useState(null);
    const { user, setUser } = useAuth()
    const { dataSourceAdmin } = useDataSource()

    const onFocusedRowChanged = React.useCallback((e) => {
        setFocusedRowKey(e.component.option('focusedRowKey'));
        setMenuId(e.component.option('focusedRowKey'))

    }, []);

    const dataSource = useMemo(() => dataSourceAdmin({
        loadUrl: "/api/Menu",
        insertUrl: "/api/Menu/FormData"
    }), [user])

    return (
        <React.Fragment>
            <div className={'content-block'}>
                <div className={'dx-card responsive-paddings'}>
                    <div className="grid-caption">Menu List</div>
                    <TreeList
                        {...getPropsTreelist}
                        id="menus-management"
                        dataSource={dataSource}
                        onFocusedRowChanged={onFocusedRowChanged}
                        focusedRowKey={focusedRowKey}
                    >
                        
                        {/* <RemoteOperations filtering={true} sorting={true} grouping={true} />  */}
                        <SearchPanel visible={true} />
                        <HeaderFilter visible={true} />
                        <Editing {...getPropsDataGridEditing}>
                            <Popup title="test" {...getPropsDataGridPopup} />
                        </Editing>
                        <Column dataField="name" ><RequiredRule /></Column>
                        <Column dataField="icon" />
                        <Column dataField="path" />
                        <Column dataField="orderId" />
                    </TreeList>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Menus
